import { createSlice } from "@reduxjs/toolkit";
import { fetchQuestById, fetchQuests } from "../Thunks/QuestsThunk";

export const questsSlice = createSlice({
  name: "quests",
  initialState: {
    isLoading: false,
    quests: [],
    error: null,
    questDetails: null,
    isQuestDetailsLoading: false,
    questDetailsError: null,
  },
  reducers: {
    clearQuestsError: (state) => {
      state.error = null;
    },
    clearQuestDetails: (state) => {
      state.questDetails = null;
      state.questDetailsError = null;
      state.isQuestDetailsLoading = false;
    },
    resetQuestsState: (state) => {
      state.quests = [];
      state.error = null;
      state.questDetails = null;
      state.questDetailsError = null;
      state.isQuestDetailsLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchQuests.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchQuests.fulfilled, (state, action) => {
      state.isLoading = false;
      state.quests = action.payload;
    });
    builder.addCase(fetchQuests.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    builder.addCase(fetchQuestById.pending, (state) => {
      state.isQuestDetailsLoading = true;
      state.questDetailsError = null;
    });
    builder.addCase(fetchQuestById.fulfilled, (state, action) => {
      state.isQuestDetailsLoading = false;
      state.questDetails = action.payload;
    });
    builder.addCase(fetchQuestById.rejected, (state, action) => {
      state.isQuestDetailsLoading = false;
      state.questDetailsError = action.payload;
    });
  },
});

export const { clearQuestDetails, clearQuestsError, resetQuestsState } =
  questsSlice.actions;

export default questsSlice.reducer;
